// extracted by mini-css-extract-plugin
export default {"root":"_32Hl0","posts":"_2eOe3"};